/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyParameterConfiguredQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PolicyParameterConfiguredQueryOperator");
    }

    getFixupPrototypeFunction() { return PolicyParameterConfiguredQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PolicyParameterConfiguredQueryOperator>): PolicyParameterConfiguredQueryOperator {
        let obj = Object.assign(new PolicyParameterConfiguredQueryOperator(), model);
        PolicyParameterConfiguredQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyParameterConfiguredQueryOperator>): PolicyParameterConfiguredQueryOperator {
        if (!model) return null;
        return PolicyParameterConfiguredQueryOperator.newInstance(<PolicyParameterConfiguredQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyParameterConfiguredQueryOperator) {
        if (!obj) return;

        models.PolicyParameterConfiguredQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyParameterConfiguredQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PolicyParameterConfiguredQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Is parameter configured to include
     */
    is_configured: boolean;

}
